import cookie from 'js-cookie';

export function clearLoginCookie() {
  return cookie.remove('gni_user');
}